export const getToolTipAttributes = (title = "tooltip", position = "top", float = false) => {
  return {
    "data-tooltip-id": "builder-tooltip",
    "data-tooltip-content": title,
    "data-tooltip-place": position,
    "data-tooltip-float": float
  };
};
